import template from './codedmedicalrecords.html';
import controller from './codedmedicalrecords.controller';
import './codedmedicalrecords.styl';

let codedmedicalrecordsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default codedmedicalrecordsComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/codedmedicalrecords/codedmedicalrecords.component.js